export enum UserRole {
  ADMIN = "admin",
  OFFICE_ADMIN = "officeAdmin",
  MANAGER = "manager",
  GROUP_MANAGER = "groupManager",
  USER = "user",
  GUEST = "guest",
}
